module.exports = __webpack_public_path__ + "img/login.c7f808de.jpg";